/* R67: etiquetas comerciales de difusores desde Shopify; las llaves de compra no cambian. */
(function(){
  if(window.VelantisNombres)return;
  var K='velantis-nombres-difusores', maps={alias:{},variante:{},handle:{}}, DF={DF002:'Scent Diffuser 3000',DF003:'Vertical Smart Diffuser',DF004:'Scent Diffuser 300',DF005:'M22 Diffuser',DF006:'Aroma Diffuser',DF007:'Portable Plug-in Diffuser'};
  try{var c=JSON.parse(localStorage.getItem(K)||'null');if(c&&c.t&&Date.now()-c.t<86400000&&c.maps)maps=c.maps;}catch(e){}
  function nombre(n,v,h){var a=maps.alias||{},vs=maps.variante||{},hs=maps.handle||{};return a[n]||vs[String(v||'').split('/').pop()]||hs[h]||n;}
  function actualizar(productos){
    var next={alias:{},variante:{},handle:{}};
    (productos||[]).forEach(function(p){
      var variants=Array.isArray(p.variants)?p.variants:((p.variants||{}).nodes||[]), alias='';
      variants.some(function(v){var s=String(v.sku||'').trim().toUpperCase();alias=DF[s]||(/^D\d{3}$/.test(s)?'Velantis Diffuser':'');return !!alias;});
      if(!alias||!p.title)return;
      var h=p.handle||String(p.onlineStoreUrl||'').split('/products/')[1];if(h)h=h.split(/[?#]/)[0];
      next.alias[alias]=p.title;if(h)next.handle[h]=p.title;
      variants.forEach(function(v){var id=String(v.id||'').split('/').pop(),aroma=alias==='Velantis Diffuser'&&v.title&&v.title!=='Default Title'?' · '+v.title:'';if(id)next.variante[id]=p.title+aroma;if(aroma)next.alias[alias+aroma]=p.title+aroma;});
    });
    if(!Object.keys(next.alias).length)return;
    /* Algunas cargas pueden contener sólo los siete aparatos, otras todo el catálogo. */
    var changed=JSON.stringify(maps)!==JSON.stringify(next);maps=next;
    try{localStorage.setItem(K,JSON.stringify({t:Date.now(),maps:maps}));}catch(e){}
    if(changed)window.dispatchEvent(new CustomEvent('velantis:nombres'));
  }
  window.VelantisNombres={nombre:nombre,actualizar:actualizar};
})();
/* ==========================================================================
   VELANTIS · EL CARRITO, UNO SOLO  (15-sep-2026)

   La casa: «Me gusta mucho más la estética del nuevo carrito (el de las fichas de
   producto); el problema es que no está conectado al del sitio [?] ni aplica las
   promociones; ese debería funcionar igual en ambos».

   Este archivo ES el carrito en la portada y en la página de producto: el mismo cajón,
   las mismas reglas, el mismo enlace de pago. Guarda en `velantis-cart`, el mismo
   almacenamiento de siempre, así que la encuesta, las tarjetas y la sección del Ritual
   Santal 33 siguen escribiendo ahí y lo que se agrega en un lado aparece en el otro.

   Reglas (las mismas que tenía la portada en index-44):
     · el nombre del renglón se cruza con el mapa vivo por nombre EXACTO y, si no está,
       sin mayúsculas ni acentos (las tarjetas escriben «Acqua de gio», el mapa
       «ACQUA DE GIO»); un aromatizante que se llama igual que un perfume («Santal 33»)
       nunca se confunde con él;
     · frasco de bolsillo de 30 ml: uno por cada 2 perfumes de 100 ml o cada 3 de 50 ml;
       SE ELIGE (pedido #1083) y mientras falte elegir no se paga; va como renglón
       «Bolsillo 30 ml · NOMBRE», el mismo que ya usaba la portada;
     · Ritual Santal 33: un Elixir de Parfum de 30 ml por cada aromatizante Santal 33,
       como renglón «Elixir de Parfum 30 ml · Santal 33»;
     · lo que no se puede cobrar en línea no se descarta en silencio: se avisa y no se
       paga hasta quitarlo.

   Se genera y se sube con SITIO-WEB/CARRITO/subir_carrito.py. No editar en el tema.
   ========================================================================== */
(function(){
  'use strict';
  if(window.__VC) return;

  var KEY = 'velantis-cart', K_MAPA = 'velantis_mapa_vivo', K_EXTRA = 'velantis-ficha-extra', K_CP = 'velantis-cp';
  /* Código explícito: viaja por el permalink nativo; Shopify valida el beneficio. */
  var K_CODIGO = 'velantis-codigo-promocional', codigoElegido = '';
  function limpiarCodigo(v){ return String(v || '').replace(/[\x00-\x1f\x7f]/g, '').trim().slice(0, 255); }
  function leerCodigo(){ try{ return limpiarCodigo(localStorage.getItem(K_CODIGO)); }catch(e){ return codigoElegido; } }
  function guardarCodigo(v){ codigoElegido=limpiarCodigo(v); try{ if(codigoElegido)localStorage.setItem(K_CODIGO,codigoElegido);else localStorage.removeItem(K_CODIGO); }catch(e){} }
  try{ var codigoURL = new URLSearchParams(location.search).get('club_code'); if(codigoURL)guardarCodigo(codigoURL); }catch(e){}
  var MARCA_REGALO = 'Bolsillo 30 ml · ';
  var CFG = window.VELANTIS_CARRITO_CFG || {};
  var PAQ = CFG.paquete || null;

  /* Escalones de envío (oct-2026) */
  var ENV_TIER1 = 500, ENV_TIER2 = 999, ENV_COST_TIER1 = 50;

  /* ------------------------------------------------ el paquete: el envío va dentro
     La casa (18-sep): «se libera a toda la república; quita el código postal y el WhatsApp;
     queda en 550 con envío incluido (no gratis)». El pago cobra el envío plano y el código
     atado a la variante lo descuenta, así que el cliente paga los $550 del anuncio.
     Si algún día vuelve a haber zona (PAQ.cpDesde/cpHasta), el cajón la vuelve a pedir sola. */
  function leerCP(){ try{ return String(localStorage.getItem(K_CP) || '').trim(); }catch(e){ return ''; } }
  function leerWA(){ try{ return String(localStorage.getItem('velantis-wa') || '').replace(/\D/g, ''); }catch(e){ return ''; } }
  function guardarCP(v){ try{ localStorage.setItem(K_CP, String(v || '').trim()); }catch(e){} }
  function zonaCP(){
    if(!PAQ || !PAQ.cpDesde || !PAQ.cpHasta) return null;
    return {ciudad: PAQ.cpCiudad || '', desde: +PAQ.cpDesde, hasta: +PAQ.cpHasta};
  }
  function cpDeLaZona(cp){
    var z = zonaCP(); if(!z) return true;                 /* sin zona configurada, como antes */
    var n = parseInt(String(cp || '').replace(/\D/g, ''), 10);
    return !!n && n >= z.desde && n <= z.hasta;
  }

  /* ------------------------------------------------------------ utilidades */
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function norm(s){ return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function pesos(n){ n=Math.round((Number(n)||0)*100)/100; return '$' + n.toLocaleString('es-MX',{minimumFractionDigits:Number.isInteger(n)?0:2,maximumFractionDigits:2}); }
  function leeJSON(k, def){ try{ var v = JSON.parse(localStorage.getItem(k)); return v == null ? def : v; }catch(e){ return def; } }

  /* ------------------------------------------------------------ el mapa
     En la portada, el vivo (#pc-conexion). En la ficha, el que la portada deja guardado
     y, si nunca se pasó por la portada, la copia que se sube con el tema. */
  var CX = null, IDX = null, K_MIO = 'velantis_carrito_mapa';
  /* La copia que guarda mapa-vivo.js NO trae perfumes, parejas ni dominio: con ella sola
     la ficha no reconocía los perfumes y quitaba el frasco de regalo. Por eso la portada
     guarda aquí el mapa completo, y lo que falte se completa con la copia del tema. */
  function completo(){ return !!(CX && CX.variantes && CX.perfumes && CX.bolsillo); }
  function cargarMapa(){
    var vivo = null;
    try{ var n = document.getElementById('pc-conexion'); if(n) vivo = JSON.parse(n.textContent); }catch(e){}
    if(vivo && vivo.variantes && vivo.perfumes){
      try{ localStorage.setItem(K_MIO, JSON.stringify({t: Date.now(), cx: vivo})); }catch(e){}
    }else{
      var mio = leeJSON(K_MIO, null);
      vivo = mio && mio.cx && mio.cx.perfumes ? mio.cx : null;
      if(!vivo){ var g = leeJSON(K_MAPA, null); vivo = g && g.cx; }
    }
    if(vivo && vivo.variantes){ CX = vivo; indexar(); return true; }
    return false;
  }
  /* El mapa vivo del tema se hornea cuando se arma la portada, así que no trae las altas
     recientes (un perfume dado de alta hoy saldría «fuera del carrito»). Por eso siempre se
     pide la copia que viaja con el tema y se rellenan los huecos: lo del vivo manda, lo nuevo
     se agrega. */
  var mapaLeido = false;
  function pedirMapa(){
    if(mapaLeido || !CFG.mapa) return Promise.resolve();
    mapaLeido = true;
    return fetch(CFG.mapa).then(function(r){ return r.json(); }).then(function(m){
      if(!m || !m.variantes) return;
      if(!CX){ CX = m; }
      else{
        Object.keys(m).forEach(function(k){
          var mio = CX[k], suyo = m[k];
          /* El catalogo descargado manda sobre los precios de un carrito guardado. */
          if((k === 'precios' || k === 'precios50') && suyo && typeof suyo === 'object'){
            CX[k] = Object.assign({}, mio || {}, suyo);
            return;
          }
          if(mio == null){ CX[k] = suyo; return; }
          if(suyo && typeof suyo === 'object' && !Array.isArray(suyo) && mio && typeof mio === 'object' && !Array.isArray(mio)){
            Object.keys(suyo).forEach(function(n){ if(mio[n] == null) mio[n] = suyo[n]; });
          }else if(Array.isArray(suyo) && Array.isArray(mio)){
            suyo.forEach(function(x){ if(mio.indexOf(x) < 0) mio.push(x); });
          }
        });
      }
      indexar();
      try{ localStorage.setItem(K_MIO, JSON.stringify({t: Date.now(), cx: CX})); }catch(e){}
    }).catch(function(){ mapaLeido = false; });
  }
  function indexar(){
    IDX = {n100: {}, n50: {}, bol: {}, perf: {}, perfX: {}, noPerf: {}, pre: {}, pre50: {}, porVar: {}, regaloPorVar: {}, dudaVar: {}, par: {}};
    var perfX = IDX.perfX;
    (CX.perfumes || []).forEach(function(n){ perfX[n] = 1; IDX.perf[norm(n)] = 1; });
    /* normalizado: si dos nombres chocan, gana el perfume */
    function idx(tabla, dest){
      var m = CX[tabla] || {};
      Object.keys(m).forEach(function(nom){
        var k = norm(nom);
        if(!(k in dest) || perfX[nom]) dest[k] = nom;
      });
    }
    idx('variantes', IDX.n100); idx('variantes50', IDX.n50); idx('bolsillo', IDX.bol);
    Object.keys(CX.bolsillo || {}).forEach(function(n){ IDX.regaloPorVar[String(CX.bolsillo[n])] = n; });
    Object.keys(CX.precios || {}).forEach(function(nom){ if(!perfX[nom]) IDX.noPerf[nom] = 1; });
    [['variantes', '100'], ['variantes50', '50']].forEach(function(par){
      var m = CX[par[0]] || {};
      Object.keys(m).forEach(function(nom){
        var v = String(m[nom]);
        if(IDX.porVar[v] && IDX.porVar[v][0] !== nom) IDX.dudaVar[v] = 1; else IDX.porVar[v] = [nom, par[1]];
      });
    });
    Object.keys(CX.parejas || {}).forEach(function(k){ IDX.par[norm(k)] = CX.parejas[k]; });
  }
  function nombreReal(tabla, dest, nom){
    var m = CX && CX[tabla]; if(!m) return null;
    if(m[nom] != null) return nom;
    var r = dest[norm(nom)]; return r || null;
  }
  function variante(nom, talla){
    if(!CX) return null;
    var real = talla === '50' ? nombreReal('variantes50', IDX.n50, nom) : nombreReal('variantes', IDX.n100, nom);
    return real ? String((talla === '50' ? CX.variantes50 : CX.variantes)[real]) : null;
  }
  function precioDe(nom, talla){
    if(!CX) return null;
    var tabla = talla === '50' ? 'precios50' : 'precios', m = CX[tabla] || {};
    if(m[nom] != null) return +m[nom];
    var real = talla === '50' ? IDX.n50[norm(nom)] : IDX.n100[norm(nom)];
    return real && m[real] != null ? +m[real] : null;
  }
  function esPerfume(nom){
    if(!CX) return false;
    if(IDX.perfX[nom]) return true;
    if(IDX.noPerf[nom]) return false;                    /* «Santal 33» aromatizante */
    if(/· Aceite|Diffuser|Difusor/i.test(nom)) return false;
    return !!IDX.perf[norm(nom)];
  }
  function bolsillo(nom){
    if(!CX || !CX.bolsillo) return null;
    var real = nombreReal('bolsillo', IDX.bol, nom);
    return real ? String(CX.bolsillo[real]) : null;
  }

  /* El selector consulta las variantes de 30 ml publicadas, disponibles y gratuitas. */
  var regalosCatalogo = null, regalosCargando = false, regalosError = false;
  var regaloBusqueda = '', regaloLimite = 3, cambiarRegalo = null;
  function todosRegalos(){
    if(regalosCatalogo) return regalosCatalogo;
    return Object.keys(CX && CX.bolsillo || {}).map(function(n){ return {n:n, rol:'30 ml incluido', busca:n}; });
  }
  function pedirRegalos(){
    if(regalosCatalogo || regalosCargando) return;
    regalosCargando = true; regalosError = false;
    var filas = [], pagina = 1;
    var ruta = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    function siguiente(){
      return fetch(ruta + 'collections/all?view=regalos-json&page=' + pagina, {credentials:'same-origin'})
        .then(function(r){ if(!r.ok) throw new Error('catalogo'); return r.json(); })
        .then(function(d){
          if(!Array.isArray(d.items)) throw new Error('catalogo');
          filas = filas.concat(d.items);
          if(d.next){ pagina++; if(pagina > 100) throw new Error('paginacion'); return siguiente(); }
        });
    }
    siguiente().then(function(){
      var nombres = {}, vistos = {}, mapa = {};
      Object.keys(CX.bolsillo || {}).forEach(function(n){ var id=String(CX.bolsillo[n]); if(!nombres[id]) nombres[id]=n; });
      regalosCatalogo = filas.filter(function(f){ if(vistos[f.id]) return false; vistos[f.id]=true; return true; }).map(function(f){
        var n=nombres[f.id] || f.title.replace(/^V\d+\s*/i,'').replace(/^Inspiraci[oó]n en\s*/i,'');
        mapa[n]=f.id;
        return {n:n, rol:'30 ml incluido', busca:f.title+' '+f.sku+' '+n, foto:f.image, id:f.id};
      }).sort(function(a,b){ return a.n.localeCompare(b.n,'es'); });
      // Preserve aliases only for variants that remain eligible.
      Object.keys(CX.bolsillo || {}).forEach(function(n){ if(vistos[String(CX.bolsillo[n])]) mapa[n]=CX.bolsillo[n]; });
      CX.bolsillo=mapa; indexar(); regalosCargando=false; pintar();
    }).catch(function(){ regalosCargando=false; regalosError=true; pintar(); });
  }
  function unaErrata(a,b){
    if(Math.abs(a.length-b.length)>1) return false;
    var i=0,j=0,cambios=0;
    while(i<a.length && j<b.length){
      if(a[i]===b[j]){ i++; j++; continue; }
      if(++cambios>1) return false;
      if(a.length>=b.length) i++;
      if(b.length>=a.length) j++;
    }
    return cambios+(a.length-i)+(b.length-j)<=1;
  }
  function pintarOpcionesRegalo(E){
    var R=raiz.querySelector('.vc-regalo'), lista=R.querySelector('.vc-regalo-lista'); if(!lista) return;
    var q=norm(regaloBusqueda), ops=[], vistos={}, ya={};
    E.puestos.forEach(function(n){ ya[norm(n)]=1; });
    if(!q) E.opciones.forEach(function(o){ vistos[norm(o.n)]=true; ops.push(o); });
    var partes=regaloBusqueda.trim().split(/\s+/).map(norm).filter(Boolean);
    var disponibles=todosRegalos();
    disponibles.forEach(function(o){
      var campos=norm(o.busca || o.n);
      if(!vistos[norm(o.n)] && (!q || partes.every(function(p){ return campos.indexOf(p)>=0; }))){
        vistos[norm(o.n)]=true; ops.push(o);
      }
    });
    // Sólo sugerir una errata si no existe una coincidencia directa.
    if(!ops.length && q.length>=5){
      disponibles.forEach(function(o){
        if(!vistos[norm(o.n)] && unaErrata(q,norm(o.n))){ vistos[norm(o.n)]=true; ops.push(o); }
      });
    }
    var limite=q?ops.length:regaloLimite;
    R.__ops=ops.slice(0,limite);
    lista.innerHTML=R.__ops.map(function(o,k){
      var sel=!!ya[norm(o.n)], foto=o.foto || fotoDe(o.n);
      return '<button type="button" class="vc-op'+(sel?' sel':'')+'" data-vc-op="'+k+'" aria-pressed="'+sel+'">'+
        '<span class="vc-op-foto">'+(foto?'<img loading="lazy" alt="" src="'+esc(foto)+'">':'')+'</span>'+
        '<span class="vc-op-n">'+esc(o.n)+'</span><em>'+(sel?'elegido':esc(o.rol))+'</em></button>';
    }).join('') + (ops.length>limite?'<button type="button" class="vc-mas-regalos" data-vc-mas>Ver más fragancias</button>':'');
    var aviso=R.querySelector('.vc-regalo-resultados');
    aviso.textContent=regalosCargando?'Cargando todas las fragancias?':
      regalosError?'No pudimos cargar el catálogo completo. Puedes volver a intentarlo.':
      !ops.length?'No encontramos esa fragancia. Prueba con otro nombre o diseñador.':
      q?ops.length+(ops.length===1?' fragancia disponible':' fragancias disponibles'):'Sugerencias para tu pedido';
    R.querySelector('[data-vc-reintentar]').hidden=!regalosError;
  }

  function pareja(nom){ return IDX && IDX.par[norm(nom)] || null; }
  function tiene50(nom){ return !!variante(nom, '50'); }

  /* ------------------------------------------------------------ fotos */
  var FOTOS = null;
  function pedirFotos(){
    if(FOTOS || !CFG.fotos) return Promise.resolve();
    return fetch(CFG.fotos).then(function(r){ return r.json(); }).then(function(f){ FOTOS = f || {}; pintar(); }).catch(function(){ FOTOS = {}; });
  }
  function fotoDe(nom){
    var fotos=FOTOS || {};
    var n = String(nom || '');
    if(n.indexOf(MARCA_REGALO) === 0) n = n.slice(MARCA_REGALO.length);
    if(PAQ && n === PAQ.obsequio) n = PAQ.regalo;
    /* 18-sep: el paquete ya tiene foto propia —las dos piezas juntas—, así que manda la suya;
       la del ambiental se queda de respaldo por si el mapa todavía no la trae. */
    if(PAQ && n === PAQ.aromatizante){
      var propia = fotos[n] || fotos[norm(n)];
      if(propia) return propia;
      if(PAQ.fotoNombre) n = PAQ.fotoNombre;
    }
    var vivo=(regalosCatalogo || []).filter(function(o){ return norm(o.n)===norm(n); })[0];
    return fotos[n] || fotos[norm(n)] || (/diffuser|difusor/i.test(n) && fotos[n.split(' · ')[0]]) || (vivo && vivo.foto) || '';
  }

  /* ------------------------------------------------------------ el almacenamiento */
  function leer(){
    var crudo = leeJSON(KEY, []);
    if(!Array.isArray(crudo)) return [];
    var out = [];
    crudo.forEach(function(it){
      if(!it || typeof it !== 'object' || !it.name) return;
      /* R78: conservar los carritos existentes al corregir nombres del catálogo. */
      var nombre = String(it.name).replace(/ENGLISH PEAR & FRESSIA/gi,'ENGLISH PEAR & FREESIA').replace(/MIRTO DI PANERA/gi,'MIRTO DI PANAREA');
      out.push({name: nombre.slice(0, 120), sub: String(it.sub || '').slice(0, 120),
        img: /^[a-z0-9 _-]{0,60}$/i.test(String(it.img || '')) ? String(it.img || '') : '',
        talla: String(it.talla) === '50' ? '50' : '100', price: Math.max(0, Math.min(100000, Number(it.price) || 0)),
        qty: Math.max(1, Math.min(20, parseInt(it.qty, 10) || 1)), v: /^\d{6,20}$/.test(String(it.v || '')) ? String(it.v) : undefined});
    });
    return out;
  }
  function guardar(items){ try{ localStorage.setItem(KEY, JSON.stringify(items)); }catch(e){} }
  function esRegalo(it){ return String(it.name).indexOf(MARCA_REGALO) === 0; }
  function esObsequio(it){ return !!(PAQ && it.name === PAQ.obsequio); }
  /* el paquete enseña lo que trae en su propio renglón, ya sin la línea del obsequio */
  function subPaquete(it){ return PAQ && it.name === PAQ.aromatizante ? 'Ambiental 250 ml · Elixir de bolsillo 30 ml' : null; }

  /* renglones que la ficha vieja guardaba aparte: se traen al carrito único */
  function migrarExtra(){
    var ex = leeJSON(K_EXTRA, null); if(!ex || !ex.length) return;
    var items = leer();
    ex.forEach(function(x){
      if(!x || !x.var) return;
      var sitio = CX && IDX.porVar[String(x.var)] && !IDX.dudaVar[String(x.var)] ? IDX.porVar[String(x.var)] : null;
      items.push({name: sitio ? sitio[0] : (x.nombre + (x.et ? ' · ' + x.et : '')), sub: '', img: '', talla: sitio ? sitio[1] : '100',
                  price: +x.precio || 0, qty: Math.max(1, +x.qty || 1), v: sitio ? undefined : String(x.var)});
    });
    guardar(items);
    try{ localStorage.removeItem(K_EXTRA); }catch(e){}
  }

  /* ------------------------------------------------------------ las reglas */
  function cuenta(items){
    var n100 = 0, n50 = 0;
    items.forEach(function(it){
      if(esRegalo(it) || esObsequio(it) || !(it.price > 0) || (it.v && IDX && IDX.regaloPorVar[String(it.v)]) || !esPerfume(it.name)) return;
      if(it.talla === '50') n50 += it.qty; else n100 += it.qty;
    });
    return {n100: n100, n50: n50, ganados: (window.VELANTIS_OFFERS && window.VELANTIS_OFFERS.gift30Enabled === true) ? Math.floor(n100 / 2) + Math.floor(n50 / 3) : 0};
  }
  function paquetes(items){
    if(!PAQ) return 0;
    var n = 0; items.forEach(function(it){ if(it.name === PAQ.aromatizante) n += it.qty; });
    return Math.min(20, n);
  }
  /* Deja el carrito coherente: regalos de más fuera, obsequio del ritual al día. */
  function acomodar(){
    var items = leer(), antes = JSON.stringify(items);
    /* R74: una variante de 30 ml nunca cuenta como una compra, aunque venga de una ficha antigua. */
    items.forEach(function(it){
      var regalo = it.v && IDX && IDX.regaloPorVar[String(it.v)];
      if(regalo){it.name = MARCA_REGALO + regalo; it.price = 0; it.qty = 1; delete it.v;}else if(!esRegalo(it) && !esObsequio(it)){
        /* Sincronizar los carritos guardados con el precio vigente del catalogo. */
        var vigente = precioDe(it.name, it.talla);
        if(vigente != null && isFinite(vigente) && vigente > 0) it.price = vigente;
      }
    });
    if(!(window.VELANTIS_OFFERS && window.VELANTIS_OFFERS.gift30Enabled === true)){ items = items.filter(function(it){ return !esRegalo(it); }); }
    var c = cuenta(items), puestos = items.filter(esRegalo);
    /* sin el mapa completo no se sabe qué es perfume: no se quita ningún regalo */
    if(completo() && puestos.length > c.ganados){
      var quitar = puestos.length - c.ganados, quedan = [];
      items.slice().reverse().forEach(function(it){ if(quitar > 0 && esRegalo(it)){ quitar--; return; } quedan.unshift(it); });
      items = quedan;
    }
    items = items.map(function(it){ if(esRegalo(it) && it.qty !== 1){ it.qty = 1; } return it; });
    /* 18-sep, la casa: «al agregar el carrito que no se añada el perfume de regalo: ya se
       incluye en el paquete y hace pensar que vamos a darles otro». El Elixir de 30 ml sigue
       yendo dentro de la caja —lo dicen la ficha y la sección—, pero ya no se pinta como
       renglón aparte. Si quedó alguno de antes en el carrito de alguien, se retira. */
    if(PAQ) items = items.filter(function(it){ return !esObsequio(it); });
    if(JSON.stringify(items) !== antes) guardar(items);
    return items;
  }
  function opciones(items){
    var ops = [], visto = {};
    items.forEach(function(it){
      if(esRegalo(it) || esObsequio(it) || !esPerfume(it.name)) return;
      var b = bolsillo(it.name);
      if(b && !visto[norm(it.name)]){ visto[norm(it.name)] = 1; ops.push({n: it.name, rol: 'versión de bolsillo'}); }
    });
    items.forEach(function(it){
      if(esRegalo(it) || esObsequio(it) || !esPerfume(it.name)) return;
      var p = pareja(it.name);
      if(p && bolsillo(p) && !visto[norm(p)]){ visto[norm(p)] = 1; ops.push({n: p, rol: 'recomendación de layering'}); }
    });
    return ops;
  }
  function publicOfferActive(){return !!(window.VelantisPromotion&&window.VelantisPromotion.active());}
  /* Buen Fin automático: sin código ni identidad del comprador. */
  var priveCodeCache={key:'',quote:null,pending:false,error:''},privePayBusy=false;
  function priveItems(E){
    if(!E.permalink)throw Error('Revisa los artículos de tu carrito antes de pagar.');
    var path=new URL(E.permalink).pathname.replace(/^\/cart\//,'');
    return path.split(',').map(function(part){var x=part.split(':');if(!/^\d+$/.test(x[0])||!/^\d+$/.test(x[1]))throw Error('No se pudo identificar un producto.');return {variantId:'gid://shopify/ProductVariant/'+x[0],quantity:Number(x[1])};});
  }
  function priveKey(items){return JSON.stringify(items.filter(function(it){return !esObsequio(it);}).map(function(it){return {id:String(it.v||variante(it.name,it.talla)||''),quantity:it.qty};}).sort(function(a,b){return a.id.localeCompare(b.id);}));}
  function descuentoPrive(items){
    var out={total:0,lineas:{},unidades:0,gratis:0};
    if(!publicOfferActive()||priveCodeCache.key!==priveKey(items)||!priveCodeCache.quote)return out;
    var q=priveCodeCache.quote;out.total=Number(q.discount);
    items.forEach(function(it,i){var id='gid://shopify/ProductVariant/'+String(it.v||variante(it.name,it.talla)||'');var line=q.lines.find(function(l){return l.variantId===id;});if(line)out.lineas[i]=line.discountCents/100;});
    return out;
  }
  function actualizarPrive(E){
    if(!publicOfferActive()){priveCodeCache={key:'',quote:null,pending:false,error:''};return;}
    var key=priveKey(E.items);if(priveCodeCache.key===key)return;
    priveCodeCache={key:key,quote:null,pending:true,error:''};
    Promise.resolve().then(function(){if(!window.VelantisPriveCode)throw Error('Actualiza la página para comprobar la oferta.');return window.VelantisPriveCode.quote(priveItems(E),true);}).then(function(q){if(priveCodeCache.key!==key)return;priveCodeCache.quote=q;priveCodeCache.pending=false;pintar();}).catch(function(e){if(priveCodeCache.key!==key)return;priveCodeCache.pending=false;priveCodeCache.error=e.message;pintar();});
  }
  function estado(){
    var items = acomodar();
    var c = cuenta(items), nPaq = paquetes(items);
    var puestos = items.filter(esRegalo).map(function(it){ return it.name.slice(MARCA_REGALO.length); });
    var ops = opciones(items);
    var total = 0, piezas = 0, van = {}, orden = [], fuera = [];
    function va(id, q){ if(!(id in van)){ van[id] = 0; orden.push(id); } van[id] += q; }
    items.forEach(function(it){
      piezas += it.qty;
      total += it.price * it.qty;
      if(esObsequio(it)) return;
      if(esRegalo(it)){ var b = bolsillo(it.name.slice(MARCA_REGALO.length)); if(b) va(b, 1); else fuera.push(it.name); return; }
      var id = it.v || variante(it.name, it.talla);
      if(id) va(id, it.qty); else fuera.push(it.name);
    });
    /* El frasco de 30 ml ya viene DENTRO del paquete de $550 (15-sep): no se agrega
       otra vez al enlace de pago; en el cajón se ve como pieza incluida, sin precio. */
    /* R75: selección explícita que el carrito nativo vuelve a comprobar contra sus cantidades. */
    try{localStorage.setItem('velantis-promo-regalos',JSON.stringify(completo() ? puestos.map(bolsillo).filter(Boolean) : []));}catch(e){}
    var puedeRegalo = todosRegalos().length > 0;
    var sinElegir = puedeRegalo ? Math.max(0, c.ganados - puestos.length) : 0;
    var dom = (CX && CX.dominio) || location.host;
    var cp = leerCP(), cpVale = cpDeLaZona(cp);
    /* solo si hay zona configurada se pide algo: hoy la promoción es igual en todo el país */
    var pideZona = !!zonaCP();
    var waNum = leerWA(), waVale = !pideZona || waNum.length === 10;
    var cpFalta = pideZona && nPaq > 0 && (!cpVale || !waVale);
    var codigoVa = nPaq && PAQ && PAQ.codigo && total < ENV_TIER2 && cpVale;
    /* 17-sep, la casa: la restricción es del paquete, no del carrito. Si además hay perfumes,
       se puede pagar el resto; lo único que se queda fuera es el paquete. */
    var idPaq = PAQ && PAQ.variante ? String(PAQ.variante) : '';
    var deVenta = cpFalta ? orden.filter(function(id){ return String(id) !== idPaq; }) : orden;
    var soloResto = cpFalta && deVenta.length > 0;
    var totalResto = 0;
    if(soloResto){
      items.forEach(function(it){
        if(esObsequio(it) || (PAQ && it.name === PAQ.aromatizante)) return;
        totalResto += it.price * it.qty;
      });
    }
    /* Lo que el pedido necesita saber de la entrega del paquete: en el pago no hay dirección
       que llenar, así que el código postal y el WhatsApp viajan como datos del carrito y
       quedan en el pedido, que es de donde ustedes los leen para coordinar. */
    var extra = [];
    var codigoPrive = '';
    try{ var prive = JSON.parse(localStorage.getItem('velantis-prive-web') || 'null'); if(prive && prive.code === 'PRIVE10') codigoPrive = 'PRIVE10'; }catch(e){}
    var codigoPromocional = leerCodigo();
    if(codigoPromocional.toUpperCase()==='PRIVE15'){guardarCodigo('');codigoPromocional='';}
    if(publicOfferActive())codigoPrive='';
    if(codigoPromocional) codigoPrive = ''; /* La elección expresa sustituye la bienvenida automática PRIVE10. */
    var codigos = [codigoVa ? PAQ.codigo : '', codigoPromocional || codigoPrive].filter(function(c,i,a){ return c && a.indexOf(c)===i; });
    if(codigos.length) extra.push('discount=' + encodeURIComponent(codigos.join(',')));
    var zc = zonaCP();
    if(zc && nPaq > 0 && cpVale && deVenta.indexOf(idPaq) >= 0){
      extra.push('attributes[Entrega]=' + encodeURIComponent('Paquete Santal 33 · a domicilio en ' + zc.ciudad));
      if(cp) extra.push('attributes[Código postal]=' + encodeURIComponent(cp));
      if(waVale && waNum) extra.push('attributes[WhatsApp]=' + encodeURIComponent(waNum));
    }
    var link = completo() && deVenta.length && !fuera.length && !sinElegir
      ? 'https://' + dom + '/cart/' + deVenta.map(function(id){ return id + ':' + Math.min(40, van[id]); }).join(',') +
        (extra.length ? '?' + extra.join('&') : '')
      : '';
    var descuento3x2=descuentoPrive(items);
    return {items: items, cuenta: c, puestos: puestos, opciones: ops, sinElegir: sinElegir, fuera: fuera,
            total: total, descuento3x2: descuento3x2, totalConDescuento: Math.round((total-descuento3x2.total)*100)/100, piezas: piezas, permalink: link, paquetes: nPaq, piso: ENV_TIER2, codigoPrive: codigoPrive, codigoPromocional: codigoPromocional,
            cp: cp, cpVale: cpVale, cpFalta: cpFalta, wa: waNum, waVale: waVale,
            soloResto: soloResto, totalResto: totalResto, zona: zonaCP(),
            /* para quien necesita IDs (las pruebas de la ficha) */
            regalosVar: puestos.map(bolsillo).filter(Boolean), opcionesVar: ops.map(function(o){ return bolsillo(o.n); }).filter(Boolean)};
  }

  /* ------------------------------------------------------------ la interfaz */
  var raiz = null, abiertoRegalo = null, tocadoRegalo = false;
  function montar(){
    if(raiz) return;
    raiz = document.createElement('div');
    raiz.id = 'vcCarrito';
    raiz.innerHTML =
      '<div class="vc-velo" hidden></div>' +
      '<aside class="vc-cajon" hidden role="dialog" aria-modal="true" aria-label="Tu carrito">' +
        '<div class="vc-cab"><b>Tu carrito</b><button type="button" class="vc-x" aria-label="Cerrar">✕</button></div>' +
        '<div class="vc-envio" hidden><span class="vc-envio-t"></span><span class="vc-barra"><i></i><b class="vc-m1" style="left:' + (ENV_TIER1/ENV_TIER2*100) + '%"></b><b class="vc-m2" style="left:100%"></b></span>' +
          '<span class="vc-cp" hidden><label>Código postal</label>' +
          '<input type="text" inputmode="numeric" maxlength="5" autocomplete="postal-code" placeholder="83000" aria-label="Código postal para la entrega"></span>' +
          '<span class="vc-cp vc-wa" hidden><label>WhatsApp</label>' +
          '<input type="tel" inputmode="numeric" maxlength="10" autocomplete="tel" placeholder="6621234567" aria-label="WhatsApp para coordinar la entrega"></span>' +
        '</div>' +
        '<div class="vc-contenido" tabindex="0" role="region" aria-label="Productos y regalo"><ul class="vc-lineas"></ul>' +
        '<div class="vc-regalo" hidden></div></div>' +
        '<div class="vc-pie">' +
          '<div class="vc-fila vc-descuento3x2" hidden><span>Descuento Buen Fin</span><b></b></div>' +
          '<div class="vc-fila"><span>Subtotal</span><b class="vc-total">$0</b></div>' +
          '<div class="vc-codigo"><label for="vcCodigoPromocional">¿Tienes un código de promoción?</label>' +
            '<div class="vc-codigo-fila"><input id="vcCodigoPromocional" type="text" maxlength="255" autocomplete="off" autocapitalize="characters" spellcheck="false" aria-describedby="vcCodigoEstado" placeholder="Escribe tu código">' +
            '<button type="button" class="vc-codigo-guardar">Usar código</button><button type="button" class="vc-codigo-quitar" hidden>Quitar</button></div>' +
            '<p id="vcCodigoEstado" role="status" aria-live="polite"></p></div>' +
          '<p class="vc-prive-benefit" hidden>Club Privé · PRIVE10<small>Tu 10% se valida al pagar con el correo registrado.</small></p>' +
          '<p class="vc-aviso" hidden></p>' +
          '<a class="vc-pagar" href="#" aria-disabled="true">Pagar</a>' +
          '<button type="button" class="vc-seguir">Seguir comprando</button>' +
        '</div>' +
      '</aside>';
    document.body.appendChild(raiz);
    raiz.querySelector('.vc-x').addEventListener('click', cerrar);
    raiz.querySelector('.vc-seguir').addEventListener('click', cerrar);
    raiz.querySelector('.vc-velo').addEventListener('click', cerrar);
    raiz.querySelector('.vc-lineas').addEventListener('click', alTocarLinea);
    raiz.querySelector('.vc-regalo').addEventListener('click', alTocarRegalo);
    raiz.querySelector('.vc-regalo').addEventListener('input', function(e){
      if(e.target.id !== 'vcRegaloBuscar') return;
      regaloBusqueda=e.target.value; regaloLimite=regaloBusqueda.trim()?8:3; pintarOpcionesRegalo(estado());
    });
    function usarCodigo(){ guardarCodigo(raiz.querySelector('#vcCodigoPromocional').value); pintar(); }
    raiz.querySelector('.vc-codigo-guardar').addEventListener('click', usarCodigo);
    raiz.querySelector('.vc-codigo-quitar').addEventListener('click', function(){ guardarCodigo(''); pintar(); });
    raiz.querySelector('#vcCodigoPromocional').addEventListener('keydown', function(e){ if(e.key==='Enter'){e.preventDefault();usarCodigo();} });
    raiz.querySelector('.vc-pagar').addEventListener('click', alPagar);
    /* «quitar el paquete» sale en el aviso cuando el código postal es de otra ciudad */
    raiz.querySelector('.vc-aviso').addEventListener('click', function(e){
      if(!e.target.closest('.vc-quitar-paq') || !PAQ) return;
      quitar(function(it){ return it.name === PAQ.aromatizante || it.name === PAQ.obsequio; });
    });
    /* el código postal decide si el paquete se puede entregar: se guarda y se repinta */
    var cpIn = raiz.querySelector('.vc-cp input');
    if(cpIn){
      cpIn.addEventListener('input', function(){
        this.value = this.value.replace(/\D/g, '').slice(0, 5);
        guardarCP(this.value); pintar();
      });
      cpIn.addEventListener('blur', function(){ guardarCP(this.value); pintar(); });
    }
    var waIn = raiz.querySelector('.vc-wa input');
    if(waIn){
      waIn.addEventListener('input', function(){
        this.value = this.value.replace(/\D/g, '').slice(0, 10);
        try{ localStorage.setItem('velantis-wa', this.value); }catch(e){}
        pintar();
      });
    }
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && estaAbierto()) cerrar(); });
  }
  function estaAbierto(){ return !!(raiz && !raiz.querySelector('.vc-cajon').hidden); }
  function abrir(){
    montar(); pedirFotos();
    raiz.querySelector('.vc-cajon').hidden = false; raiz.querySelector('.vc-velo').hidden = false;
    document.documentElement.classList.add('vc-abierto');
    pintar();
  }
  function cerrar(){
    if(!raiz) return;
    raiz.querySelector('.vc-cajon').hidden = true; raiz.querySelector('.vc-velo').hidden = true;
    document.documentElement.classList.remove('vc-abierto');
  }

  function pintar(){
    var E = estado();
    if(E.cuenta.ganados && !regalosCatalogo && !regalosCargando && !regalosError) pedirRegalos();
    var foco=raiz && raiz.querySelector('#vcRegaloBuscar');
    var restaurarFoco=foco && document.activeElement===foco;
    contadores(E.piezas);
    if(!raiz) return E;
    var L = raiz.querySelector('.vc-lineas');
    if(!E.items.length){
      L.innerHTML = '<li class="vc-vacio">Tu carrito está vacío.</li>';
    }else{
      L.innerHTML = E.items.map(function(it, i){
        var foto = fotoDe(it.name), regalo = esRegalo(it), obs = esObsequio(it);
        /* la leyenda de abajo ya dice que va incluido: el renglón no lo repite */
        var sub = regalo ? 'Frasco de bolsillo de 30 ml'
          : (obs ? String(it.sub || '').replace(/^Obsequio de la casa\s*·\s*/, '')
            : (subPaquete(it) || (esPerfume(it.name) ? '' : it.sub)));
        var tallas = !regalo && !obs && esPerfume(it.name) && tiene50(it.name)
          ? '<span class="vc-tallas">' + ['50', '100'].map(function(t){
              return '<button type="button" data-vc-i="' + i + '" data-vc-t="' + t + '"' + (it.talla === t ? ' class="on" aria-pressed="true"' : ' aria-pressed="false"') + '>' + t + ' ml</button>'; }).join('') + '</span>'
          : (!regalo && !obs && esPerfume(it.name) ? '<span class="vc-d">' + it.talla + ' ml</span>' : '');
        return '<li class="vc-l' + (regalo || obs ? ' vc-l-regalo' : '') + '">' +
          '<span class="vc-foto"' + (foto ? ' style="background-image:url(\'' + esc(foto) + '&width=160\')"' : '') + '></span>' +
          '<span class="vc-info"><span class="vc-n">' + esc(window.VelantisNombres.nombre(it.name,it.v || variante(it.name,it.talla))) + '</span>' +
            (sub ? '<span class="vc-d' + (regalo || obs ? ' vc-oro' : '') + '">' + esc(sub) + '</span>' : '') + tallas +
            (regalo || obs
              ? '<span class="vc-incluido">' + (obs ? 'Obsequio de la casa' : 'Incluido') + (it.qty > 1 ? ' · ' + it.qty : '') + '</span>' + (regalo ? '<span class="vc-regalo-editar"><button type="button" data-vc-i="' + i + '" data-vc-cambiar>Cambiar</button><button type="button" data-vc-i="' + i + '" data-vc-d="x">Quitar</button></span>' : '')
              : '<span class="vc-q"><button type="button" data-vc-i="' + i + '" data-vc-d="-1" aria-label="Quitar uno">−</button><b>' + it.qty + '</b>' +
                '<button type="button" data-vc-i="' + i + '" data-vc-d="1" aria-label="Agregar uno">+</button>' +
                '<button type="button" class="vc-quitar" data-vc-i="' + i + '" data-vc-d="x">Quitar</button></span>') +
          '</span>' +
          /* el regalo no lleva precio: un «$0» en el renglón se lee como si algo valiera nada
             (la casa, 15-sep). La leyenda «Incluido / Obsequio de la casa» ya lo dice. */
          '<span class="vc-p">' + (regalo || obs ? '' : (E.descuento3x2.lineas[i] ? '<s>' + pesos(it.price*it.qty) + '</s><strong>' + pesos(it.price*it.qty-E.descuento3x2.lineas[i]) + '</strong>' : pesos(it.price*it.qty))) + '</span>' +
        '</li>';
      }).join('');
    }
    raiz.querySelector('.vc-total').textContent = pesos(E.totalConDescuento);
    var descuentoFila=raiz.querySelector('.vc-descuento3x2');descuentoFila.hidden=!E.descuento3x2.total;descuentoFila.querySelector('b').textContent='−'+pesos(E.descuento3x2.total);

    var env = raiz.querySelector('.vc-envio');
    env.hidden = !E.items.length;
    if(E.items.length){
      /* Escalones de envío: $50 desde $500, gratis desde $999. */
      var totalEnvio = E.totalConDescuento;
      var faltaGratis = ENV_TIER2 - totalEnvio, faltaDesc = ENV_TIER1 - totalEnvio, hayPaq = E.paquetes > 0;
      var ciudad = (E.zona && E.zona.ciudad) || 'Hermosillo';
      var texto;
      if(hayPaq && E.cpFalta && !E.cp) texto = '<b>Tu Paquete se entrega en ' + esc(ciudad) + '.</b> Escribe tu código postal para continuar.';
      else if(hayPaq && E.cpFalta && !E.cpVale) texto = '<b>El Paquete solo se entrega en ' + esc(ciudad) + '.</b> Con ese código postal no podemos llevártelo.';
      else if(hayPaq && E.cpFalta) texto = '<b>Entrega en ' + esc(ciudad) + '.</b> Déjanos tu WhatsApp para acordarla.';
      else if(hayPaq) texto = '<b>Envío incluido en tu Paquete</b>, a toda la República · <span class="vc-envio-x">total ' + pesos(totalEnvio) + '</span>';
      else if(faltaGratis <= 0) texto = '<b>Envío gratis incluido.</b>';
      else if(totalEnvio >= ENV_TIER1) texto = 'Envío a <b>' + pesos(ENV_COST_TIER1) + '</b>. Te faltan <b>' + pesos(faltaGratis) + '</b> para el envío gratis.';
      else texto = 'Te faltan <b>' + pesos(faltaDesc) + '</b> para envío a ' + pesos(ENV_COST_TIER1) + '.';
      env.querySelector('.vc-envio-t').innerHTML = texto;
      /* los dos campos solo se piden si la promoción vuelve a tener zona (hoy no la tiene) */
      var caja = env.querySelector('.vc-cp'), cajaWa = env.querySelector('.vc-wa');
      var pideDatos = hayPaq && !!E.zona;
      caja.hidden = !pideDatos;
      cajaWa.hidden = !pideDatos;
      if(pideDatos){
        var inp = caja.querySelector('input');
        if(document.activeElement !== inp) inp.value = E.cp || '';
        caja.classList.toggle('mal', !!E.cp && !E.cpVale);
        var inpWa = cajaWa.querySelector('input');
        if(document.activeElement !== inpWa) inpWa.value = E.wa || '';
        cajaWa.classList.toggle('mal', !!E.wa && !E.waVale);
      }
      env.querySelector('.vc-barra').hidden = hayPaq;   /* con paquete el envío ya va dentro */
      var pct;
      if(totalEnvio >= ENV_TIER2) pct = 100;
      else if(totalEnvio >= ENV_TIER1) pct = (ENV_TIER1/ENV_TIER2*100) + ((totalEnvio - ENV_TIER1) / (ENV_TIER2 - ENV_TIER1) * (100 - ENV_TIER1/ENV_TIER2*100));
      else pct = Math.max(4, (totalEnvio / ENV_TIER1) * (ENV_TIER1/ENV_TIER2*100));
      var barra = env.querySelector('.vc-barra');
      barra.querySelector('i').style.width = pct + '%';
      barra.querySelector('.vc-m1').classList.toggle('on', totalEnvio >= ENV_TIER1);
      barra.querySelector('.vc-m2').classList.toggle('on', totalEnvio >= ENV_TIER2);
    }

    /* el frasco de bolsillo. OJO con los atributos: el carrito viejo de la portada (index-44)
       intercepta en captura cualquier clic sobre [data-abrir] y [data-regalo], así que los del
       cajón nuevo llevan prefijo vc- para que no se los trague. */
    var R = raiz.querySelector('.vc-regalo');
    if(E.cuenta.ganados && (todosRegalos().length || regalosCargando || regalosError)){
      if(abiertoRegalo === null) abiertoRegalo = false;
      var falta2 = E.cuenta.ganados - E.puestos.length, ya = {};
      E.puestos.forEach(function(n){ ya[norm(n)] = 1; });
      R.hidden = false;
      R.classList.toggle('falta', falta2 > 0);
      R.innerHTML =
        '<button type="button" class="vc-regalo-cab" data-vc-toggle="1" aria-expanded="' + (abiertoRegalo ? 'true' : 'false') + '">' +
          '<span><b>' + (E.cuenta.ganados > 1 ? 'Tus ' + E.cuenta.ganados + ' frascos de bolsillo de 30 ml van incluidos' : 'Tu frasco de bolsillo de 30 ml va incluido') + '</b>' +
          '<span class="vc-regalo-cuenta">' + esc(E.puestos.length
            ? 'Elegiste ' + E.puestos.length + ' de ' + E.cuenta.ganados + ': ' + E.puestos.join(', ') + (falta2 > 0 ? ' · falta ' + falta2 : '')
            : (E.cuenta.ganados > 1 ? 'Elige ' + E.cuenta.ganados + ' de la lista' : 'Elige cualquier fragancia disponible')) + '</span></span>' +
          '<span class="vc-regalo-accion">' + (abiertoRegalo ? 'cerrar' : (E.puestos.length ? 'cambiar' : 'elegir regalo')) + '</span>' +
        '</button>' +
        '<div class="vc-regalo-ops"' + (abiertoRegalo ? '' : ' hidden') + '>' +
          '<label class="vc-regalo-label" for="vcRegaloBuscar">Busca tu fragancia de 30 ml</label>' +
          '<input id="vcRegaloBuscar" type="search" autocomplete="off" placeholder="Nombre, diseñador o código" value="' + esc(regaloBusqueda) + '">' +
          '<p class="vc-regalo-resultados" role="status" aria-live="polite"></p>' +
          '<button type="button" data-vc-reintentar hidden>Volver a cargar</button>' +
          '<div class="vc-regalo-lista"></div>' +
        '</div>';
      pintarOpcionesRegalo(E);
      if(restaurarFoco){ var nuevo=R.querySelector('#vcRegaloBuscar'); nuevo.focus({preventScroll:true}); }

    }else{
      R.hidden = true; R.innerHTML = ''; abiertoRegalo = null; tocadoRegalo = false;
    }

    var A = raiz.querySelector('.vc-aviso'), P = raiz.querySelector('.vc-pagar');
    A.hidden = !(E.sinElegir || E.fuera.length || E.cpFalta);
    if(E.fuera.length) A.innerHTML = '<b>No podemos cobrar en línea ' + esc(E.fuera.slice(0, 2).join(', ')) + (E.fuera.length > 2 ? ' y ' + (E.fuera.length - 2) + ' más' : '') + '.</b> Quítalo del carrito para pagar el resto.';
    /* No es un premio ni un concurso: ya viene en el pedido y solo falta decir de cuál (la casa, 16-sep). */
    else if(E.sinElegir) A.innerHTML = '<b>Tu pedido incluye ' + (E.sinElegir > 1 ? E.sinElegir + ' frascos de bolsillo de 30 ml' : 'un frasco de bolsillo de 30 ml') + '.</b> Elige ' + (E.sinElegir > 1 ? 'las fragancias' : 'la fragancia') + ' para continuar con tu pedido.';
    /* el aviso del código postal solo se escribe si no hay otro más urgente */
    if(!E.fuera.length && !E.sinElegir && E.cpFalta){
      var cd = (E.zona && E.zona.ciudad) || 'Hermosillo';
      A.innerHTML = (!E.cp
        ? '<b>El Paquete Santal 33 se entrega en ' + esc(cd) + '.</b> Escribe tu código postal para poder continuar.'
        : (!E.cpVale
          ? '<b>El Paquete Santal 33 solo se entrega en ' + esc(cd) + '.</b> ' +
            (E.soloResto ? 'Lo demás sí te lo mandamos: puedes pagar el resto de tu pedido.' : 'Escríbenos si vas a recogerlo.')
          : '<b>Falta tu WhatsApp.</b> La entrega del Paquete se coordina contigo el mismo día; sin número no podemos acordarla.')) +
        ' <button type="button" class="vc-quitar-paq">Quitar el paquete</button>';
    }
    P.href = E.permalink || '#';
    P.setAttribute('aria-disabled', E.permalink ? 'false' : 'true');
    P.textContent = E.permalink
      ? (E.soloResto ? 'Pagar el resto · ' + pesos(E.totalResto) : 'Pagar · ' + pesos(E.totalConDescuento))
      : (E.sinElegir ? 'Elige tu frasco para pagar'
        : (E.cpFalta ? (!E.cp ? 'Escribe tu código postal'
                       : (!E.cpVale ? 'Fuera de zona de entrega' : 'Déjanos tu WhatsApp')) : 'Pagar'));
    P.dataset.falta = E.sinElegir ? '1' : '';
    P.dataset.cp = E.cpFalta ? '1' : '';
    var priveBenefit = raiz.querySelector('.vc-prive-benefit');if(priveBenefit)priveBenefit.hidden = !E.codigoPrive;
    var codigoInput = raiz.querySelector('#vcCodigoPromocional');
    var codigoBox=codigoInput.closest('.vc-codigo');if(codigoBox)codigoBox.hidden=publicOfferActive();
    if(document.activeElement !== codigoInput)codigoInput.value = E.codigoPromocional || '';
    raiz.querySelector('.vc-codigo-quitar').hidden = !E.codigoPromocional;
    raiz.querySelector('#vcCodigoEstado').textContent = E.descuento3x2.total ? 'Buen Fin: ahorras ' + pesos(E.descuento3x2.total) + '. El descuento se confirma al pagar.' : (E.codigoPromocional ? 'Código ' + E.codigoPromocional + ' guardado. Shopify validará el descuento al pagar.' : '');

    if(publicOfferActive()){
      var valid=priveCodeCache.key===priveKey(E.items)&&priveCodeCache.quote;
      raiz.querySelector('.vc-descuento3x2 span').textContent='Descuento Buen Fin';
      raiz.querySelector('#vcCodigoEstado').textContent=priveCodeCache.error|| (valid ? 'Buen Fin automático: 3×2 en 100 ml y 15% en aromatizantes elegibles. 50 ml, aceites y difusores a precio regular.' : 'Confirmando descuento automático...');
      if(valid){raiz.querySelector('.vc-total').textContent=pesos(Number(valid.net));P.textContent='Pagar · '+pesos(Number(valid.net));}
      if(privePayBusy){P.textContent='Abriendo pago de Shopify...';P.setAttribute('aria-disabled','true');}
      actualizarPrive(E);
    }
    window.__VC_ESTADO = E;
    if(typeof CFG.alPintar === 'function'){ try{ CFG.alPintar(E); }catch(e){} }
    return E;
  }
  function contadores(n){
    var d = document.querySelectorAll('.cart-dot, [data-vc-cuenta]');
    for(var i = 0; i < d.length; i++){ if(d[i].textContent !== String(n)) d[i].textContent = n; }
  }

  function alTocarLinea(e){
    var b = e.target.closest('button[data-vc-i]'); if(!b) return;
    var items = leer(), i = +b.dataset.vcI, it = items[i]; if(!it || esObsequio(it)) return;
    if(esRegalo(it)){
      if(b.hasAttribute('data-vc-cambiar')) cambiarRegalo=it.name;
      else if(b.dataset.vcD==='x'){ items.splice(i,1); guardar(items); cambiarRegalo=null; }
      else return;
      regaloBusqueda=''; regaloLimite=3; tocadoRegalo=true; abiertoRegalo=true; pintar();
      var bus=raiz.querySelector('#vcRegaloBuscar'); if(bus){ bus.scrollIntoView({block:'center',behavior:'smooth'}); bus.focus({preventScroll:true}); }
      return;
    }
    if(b.dataset.vcT){
      it.talla = b.dataset.vcT;
      var p = precioDe(it.name, it.talla); if(p != null) it.price = p;
      /* si ya hay un renglón igual en esa talla, se juntan */
      var otro = items.filter(function(x, k){ return k !== i && x.name === it.name && x.talla === it.talla; })[0];
      if(otro){ otro.qty = Math.min(20, otro.qty + it.qty); items.splice(i, 1); }
    }else if(b.dataset.vcD === 'x'){ items.splice(i, 1); }
    else{ it.qty += +b.dataset.vcD; if(it.qty <= 0) items.splice(i, 1); else it.qty = Math.min(20, it.qty); }
    guardar(items); pintar();
  }
  function alTocarRegalo(e){
    var R = raiz.querySelector('.vc-regalo');
    if(e.target.closest('[data-vc-reintentar]')){ pedirRegalos(); pintar(); return; }
    if(e.target.closest('[data-vc-mas]')){ regaloLimite+=10; pintarOpcionesRegalo(estado()); return; }
    if(e.target.closest('[data-vc-toggle]')){ tocadoRegalo = true; abiertoRegalo = !abiertoRegalo; pintar(); return; }
    var b = e.target.closest('[data-vc-op]'); if(!b) return;
    var o = (R.__ops || [])[+b.dataset.vcOp]; if(!o) return;
    var items = leer(), mio = MARCA_REGALO + o.n;
    if(!bolsillo(o.n) || cuenta(items).ganados < 1) return;
    var estaba = items.some(function(it){ return esRegalo(it) && norm(it.name) === norm(mio); });
    if(estaba){
      items = items.filter(function(it){ return !(esRegalo(it) && norm(it.name) === norm(mio)); });
    }else{
      if(cambiarRegalo) items=items.filter(function(it){ return it.name!==cambiarRegalo; });
      var caben = cuenta(items).ganados, puestos = items.filter(esRegalo);
      if(puestos.length >= caben && puestos.length){ var ido = false; items = items.filter(function(it){ if(!ido && esRegalo(it)){ ido = true; return false; } return true; }); }
      items.push({name: mio, price: 0, img: '', sub: 'Regalo de tu promoción · frasco de bolsillo 30 ml', qty: 1, talla: '100'});
    }
    cambiarRegalo=null; regaloBusqueda=''; regaloLimite=3; tocadoRegalo = true; abiertoRegalo=true;
    guardar(items); var E = pintar();
    if(!E.sinElegir){ abiertoRegalo = false; pintar(); }
  }
  function alPagar(e){
    var P = raiz.querySelector('.vc-pagar');
    var E = estado();
    /* R74: el enlace se reconstruye con el carrito de este clic, no con una versión anterior. */
    /* El checkout nativo aplica ambos descuentos automáticos sin código. */
    if(!E.permalink){e.preventDefault();pintar();}
    else {P.href=E.permalink;P.setAttribute('aria-disabled','false');}
    if(CX && CX.modo === 'whatsapp' && E.items.length){
      e.preventDefault();
      var S = String.fromCharCode(10), lista = ['Hola, vengo de la página. Quiero:', ''];
      E.items.forEach(function(it){ lista.push('• ' + it.qty + ' × ' + it.name + (esPerfume(it.name) ? ' (' + it.talla + ' ml)' : '') + (it.price ? ' — ' + pesos(it.price * it.qty) : '')); });
      lista.push('', 'Total: ' + pesos(E.total));
      window.open(CX.wa + '?text=' + encodeURIComponent(lista.join(S)), '_blank', 'noopener');
      return;
    }
    if(P.getAttribute('aria-disabled') === 'true'){
      e.preventDefault();
      if(P.dataset.falta){
        abiertoRegalo = true; pintar();
        var R = raiz.querySelector('.vc-regalo'); if(R) R.scrollIntoView({block: 'center', behavior: 'smooth'});
        window.alert('Tu pedido incluye un frasco de bolsillo de 30 ml. Elige la fragancia para continuar con tu pedido.');
      }else if(P.dataset.cp){
        /* el paquete se entrega en la ciudad y se coordina por WhatsApp: sin esos dos, no hay pago */
        var E2 = estado();
        var campo = raiz.querySelector(E2.cpVale ? '.vc-wa input' : '.vc-cp input');
        if(campo){ campo.focus(); campo.select(); }
      }
    }
  }

  /* ------------------------------------------------------------ la API de siempre */
  function add(item){
    if(!item || !item.name) return;
    if(String(item.talla) === '30' || /-30$/.test(String(item.sku || ''))) return;   /* el 30 ml solo entra como regalo */
    if(item.v && IDX && IDX.regaloPorVar[String(item.v)]) return; /* un 30 ml no entra como compra directa */
    var tl = String(item.talla) === '50' ? '50' : '100';
    var items = leer();
    if(String(item.name).indexOf(MARCA_REGALO) === 0){
      if(!completo() || !bolsillo(String(item.name).slice(MARCA_REGALO.length)) || cuenta(items).ganados <= items.filter(esRegalo).length) return;
      if(!items.some(function(x){ return x.name === item.name; })) items.push({name: item.name, price: 0, img: '', sub: item.sub || '', qty: 1, talla: '100'});
    }else{
      var f = items.filter(function(x){ return x.name === item.name && x.talla === tl; })[0];
      if(f) f.qty = Math.min(20, f.qty + (parseInt(item.qty, 10) || 1));
      else items.push({name: item.name, price: +item.price || 0, img: item.img || '', sub: item.sub || '', qty: Math.max(1, parseInt(item.qty, 10) || 1), talla: tl,
                       v: item.v ? String(item.v) : undefined});
    }
    guardar(items); pintar();
    if(item.abrir !== false) abrir();
  }
  /* la ficha agrega por ID de variante: se traduce al nombre del sitio */
  var mapaPedido = false;
  function addVariante(v, datos){
    datos = datos || {};
    /* entró directo a la ficha y el mapa todavía viene en camino: se espera una vez */
    if(!completo() && CFG.mapa && !mapaPedido){ mapaPedido = true; pedirMapa().then(function(){ addVariante(v, datos); }); return; }   /* eslint-disable-line */
    /* 16-sep: el paquete comprado desde su PROPIA página entraba con el título largo del
       producto, y como toda la promoción se reconoce por el nombre corto, se quedaba sin el
       Elixir incluido, sin el envío a mitad y sin el código en el enlace de pago. Ahora la
       variante manda: si es la del paquete, se guarda con su nombre de siempre. */
    if(PAQ && PAQ.variante && String(v) === String(PAQ.variante)){
      add({name: PAQ.aromatizante, talla: '100', price: datos.precio, sub: datos.et || '',
           v: String(v), qty: datos.qty, abrir: datos.abrir});
      return;
    }
    if(IDX && IDX.regaloPorVar[String(v)]) return; /* se elige en el selector de promoción */
    var sitio = CX && IDX.porVar[String(v)] && !IDX.dudaVar[String(v)] ? IDX.porVar[String(v)] : null;
    /* 16-sep: si la variante no está en el índice, la talla salía SIEMPRE '100' aunque la
       etiqueta dijera «50 ml». Cobraba bien, pero el conteo del regalo (2x100 o 3x50) contaba
       mal. La etiqueta de la ficha ya trae la talla: se lee de ahí. */
    var tlEt = String(datos.et || '').match(/(\d{2,3})\s*ml/i);
    add({name: sitio ? sitio[0] : datos.nombre, talla: sitio ? sitio[1] : (tlEt ? tlEt[1] : '100'),
         price: datos.precio, sub: sitio ? '' : (datos.et || ''),
         v: sitio ? undefined : String(v), qty: datos.qty, abrir: datos.abrir});
  }
  function recargar(){ pintar(); }
  /* quita UNA pieza de esa variante (la ficha: «En tu carrito» se desmarca) */
  function restarVariante(v){
    var items = leer(), v2 = String(v);
    for(var i = items.length - 1; i >= 0; i--){
      var it = items[i]; if(esRegalo(it) || esObsequio(it)) continue;
      if((it.v || variante(it.name, it.talla)) === v2){ it.qty -= 1; if(it.qty <= 0) items.splice(i, 1); break; }
    }
    guardar(items); pintar();
  }
  function quitar(pred){ guardar(leer().filter(function(it){ return !pred(it); })); pintar(); }

  var API = {envios: {umbralDescuento: ENV_TIER1, umbralGratis: ENV_TIER2, tarifaReducida: ENV_COST_TIER1}, add: add, addVariante: addVariante, restarVariante: restarVariante, open: abrir, close: cerrar, recargar: recargar, quitar: quitar,
             estado: estado, variante: variante, esPerfume: esPerfume, nuevo: true};
  window.__VC = API;
  window.VelantisCart = API;

  /* ------------------------------------------------------------ arranque */
  function arrancar(){
    cargarMapa();
    montar();
    if(completo()){ pintar(); migrarExtra(); }
    pedirMapa().then(function(){ migrarExtra(); pintar(); });
    /* el icono y el botón flotante de la portada abren ESTE cajón */
    document.addEventListener('click', function(e){
      var t = e.target.closest('.tools .icon-btn[aria-label="Carrito"], #vFlotCarrito, [data-vc-abrir]');
      if(!t) return;
      e.preventDefault(); e.stopImmediatePropagation(); abrir();
    }, true);
    /* otras pestañas y la encuesta en su marco escriben el mismo almacenamiento */
    window.addEventListener('storage', function(e){ if(e.key === KEY || e.key === K_CODIGO) pintar(); });
    window.addEventListener('velantis:nombres',function(){pintar();});
    window.addEventListener('velantis:promotion',function(){priveCodeCache={key:'',quote:null,pending:false,error:''};pintar();});
    /* red de seguridad: si algún módulo del sitio escribe directo al almacenamiento */
    var ultimo = localStorage.getItem(KEY);
    setInterval(function(){ var ahora = localStorage.getItem(KEY); if(ahora !== ultimo){ ultimo = ahora; pintar(); } }, 700);
    if(CX && !FOTOS) pedirFotos();
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
})();
